import React from "react";
import { useTranslation } from "react-i18next";
import { AlertCircle, AlertTriangle } from "lucide-react";
import { CheckFindingSeverity } from "../../../models/InvoiceBatch";

interface Props {
	severity: CheckFindingSeverity;
}

/** Marks an invoice row that the latest (current) dry run found errors or warnings on. */
const InvoiceDryRunMarker: React.FC<Props> = ({ severity }) => {
	const { t } = useTranslation();
	const label = t(`invoiceBatch.dryRun.rowMarker.${severity}` as any) as string;

	return (
		<span
			role="img"
			aria-label={label}
			title={label}
			className={
				severity === "error"
					? "mr-1.5 inline-flex align-text-bottom text-red-600"
					: "mr-1.5 inline-flex align-text-bottom text-amber-600"
			}
		>
			{severity === "error" ? <AlertCircle size={16} /> : <AlertTriangle size={16} />}
		</span>
	);
};

export default InvoiceDryRunMarker;
